import getThreadContentItemByThreadId from '@/lib/threads/getThreadContentItemByThreadId.js';
import getThreadsById from '@/lib/threads/getThreadsById.js';
import upsertSortedThread from '@/lib/threads/upsertSortedThread.js';
import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';
import isThreadArchiveAlreadyGoneFailure from '@/redux/reducers/pieveReducer/isThreadArchiveAlreadyGoneFailure.js';

/**
 * Settles a failed thread archive. When the failure proves the thread is already
 * gone server-side the optimistic removal stays; transient failures restore the
 * snapshot taken when the archive started.
 */
const applyArchiveThreadFail = ({ state, payload } = {}) => {
  const threadId = String(payload?.resourceId || payload?.meta?.threadId || '').trim();
  const requestId = String(payload?.requestId || payload?.meta?.requestId || '').trim();

  if (!threadId || !requestId || state?.archivedThreadPendingRequestIdByThreadId?.[threadId] !== requestId) {
    return state;
  }

  const snapshot = state?.archivedThreadSnapshotByThreadId?.[threadId] || null;
  const nextArchivedThreadSnapshotByThreadId = { ...(state?.archivedThreadSnapshotByThreadId || {}) };
  const nextArchivedThreadPendingRequestIdByThreadId = { ...(state?.archivedThreadPendingRequestIdByThreadId || {}) };
  delete nextArchivedThreadSnapshotByThreadId[threadId];
  delete nextArchivedThreadPendingRequestIdByThreadId[threadId];

  if (!snapshot || isThreadArchiveAlreadyGoneFailure(payload) || getThreadsById(state.threads)?.[threadId] || getThreadContentItemByThreadId(state.threadContent, threadId)) {
    return {
      ...state,
      archivedThreadSnapshotByThreadId: nextArchivedThreadSnapshotByThreadId,
      archivedThreadPendingRequestIdByThreadId: nextArchivedThreadPendingRequestIdByThreadId
    };
  }

  return {
    ...state,
    threads: snapshot.threadMeta ? upsertSortedThread(state.threads, snapshot.threadMeta) : state.threads,
    threadContent: snapshot.threadContent ? upsertThreadContentItem(state.threadContent, { ...snapshot.threadContent, threadId }) : state.threadContent,
    archivedThreadSnapshotByThreadId: nextArchivedThreadSnapshotByThreadId,
    archivedThreadPendingRequestIdByThreadId: nextArchivedThreadPendingRequestIdByThreadId
  };
};

export default applyArchiveThreadFail;
